/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportDailyTaskVm } from '../../models/report-daily-task-vm';
import { UpdateMaintenanceReportCommandResult } from '../../models/update-maintenance-report-command-result';

export interface ApiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Params {
      body?: {
'Id'?: string;
'ProjectId'?: string;
'Notes'?: string;
'ReportDailyTasks'?: Array<ReportDailyTaskVm>;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch(http: HttpClient, rootUrl: string, params?: ApiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateMaintenanceReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateMaintenanceReportCommandResult>;
    })
  );
}

apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch.PATH = '/api/ProjectMaintenanceReport/UpdateProjectMaintenanceReport';
